/* Pure cart contract shared by the product form and its dependency-free tests. */
(function (root) {
  'use strict';
  function positiveInteger(value, name) {
    const number = Number(value);
    if (!Number.isSafeInteger(number) || number < 1) throw new TypeError(name);
    return number;
  }
  function buildWrappedItems(state) {
    const id = positiveInteger(state.variantId, 'variantId');
    const quantity = positiveInteger(state.quantity, 'quantity');
    const properties = { ...(state.properties || {}) };
    delete properties._wrap_group;
    delete properties[state.propertyName];
    const main = { id, quantity, properties };
    if (!state.gift || state.gift === 'none') return [main];
    const choices = state.gift.split(',');
    if (choices.some(choice => !['wrapping', 'paper'].includes(choice)) || new Set(choices).size !== choices.length) throw new TypeError('gift');
    const bags = ['wrapping', 'paper'].filter(choice => choices.includes(choice)).map(choice => state.options[choice]);
    if (bags.some(bag => !bag || !bag.available || !bag.value) || !state.propertyName || !state.groupId) throw new TypeError('gift option unavailable');
    main.properties[state.propertyName] = bags.map(bag => bag.value).join('・');
    main.properties._wrap_group = state.groupId;
    return [main, ...bags.map(bag => ({ id: positiveInteger(bag.variantId, 'bag.variantId'), quantity, properties: { _wrap_group: state.groupId } }))];
  }
  function buildItems(state) {
    const items = buildWrappedItems(state);
    if (state.noshi) {
      const contract = typeof module !== 'undefined' && module.exports ? require('./noshi-contract.js') : root.ChaponNoshi;
      const noshi = contract.build(state.noshi.selection, state.noshi.catalog, { ...state.noshi, quantity: items[0].quantity });
      Object.assign(items[0].properties, noshi.summary);
      items.push(noshi.item);
    }
    return items;
  }
  function findMain(items, { key, variantId }) {
    const matchingVariant = item => String(item.variant_id ?? item.id) === String(variantId);
    if (key) {
      const main = items.find(item => item.key === key && matchingVariant(item));
      if (main) return main;
    }
    const candidates = items.filter(item => matchingVariant(item) && !item.properties?._wrap_group && !item.properties?._noshi_group);
    return candidates.length === 1 ? candidates[0] : null;
  }
  const api = { buildItems, findMain };
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  else root.ChaponProductCart = api;
})(typeof globalThis !== 'undefined' ? globalThis : this);
